import { nonNullishOrThrow } from '@web-platform/shared-universal-utils-frontend/src/helpers/assertNonNullish';
import { logError } from '@web-platform/shared-universal-utils-frontend/src/helpers/logger';

import type {
  SkyscannerSonarCommonV1Carrier,
  SkyscannerSonarV3Response,
} from '@skyscanner-internal/sonar-web-http-client';
import type { CarrierBookingPanel as CarrierEntity } from '@web-platform/shared-universal-types/src/redux/state/shared/flightBookingPanel/entities/flights/carriersBookingPanel';

type Carrier = SkyscannerSonarCommonV1Carrier.Carrier;
type Leg = SkyscannerSonarV3Response.Leg;

export const mapSonarV3Carriers = (
  legs: Leg[] | undefined,
  state: Record<number, CarrierEntity>,
  carrierLogos?: Record<number, string>,
): CarrierEntity[] => {
  const carrierIds = new Set();
  const carriers: CarrierEntity[] = [];

  const mapCarrier = (carrier: Carrier) => {
    const validCarrier: CarrierEntity = {
      id: nonNullishOrThrow(carrier.id, 'carrier.id'),
      name: nonNullishOrThrow(carrier.name, 'carrier.name'),
      alt_id: nonNullishOrThrow(carrier.altId, 'carrier.altId'),
      display_code: nonNullishOrThrow(carrier.displayCode, 'carrier.displayCode'),
    };

    if (carrierLogos && carrierLogos[validCarrier.id]) {
      validCarrier.multiModalLogoUrl = carrierLogos[validCarrier.id];
    }

    if (!carrierIds.has(validCarrier.id)) {
      carriers.push({
        ...state[validCarrier.id],
        ...validCarrier,
      });
      carrierIds.add(validCarrier.id);
    }
  };

  try {
    nonNullishOrThrow(legs, 'legs').forEach((leg) => {
      nonNullishOrThrow(leg.segments, 'leg.segments').forEach((segment) => {
        mapCarrier(nonNullishOrThrow(segment.marketingCarrier, 'segment.marketingCarrier'));
        mapCarrier(nonNullishOrThrow(segment.operatingCarrier, 'segment.operatingCarrier'));
      });
    });

    return carriers;
  } catch (error) {
    logError({
      component: 'mapSonarV3Carriers',
      data: JSON.stringify(legs),
      error,
      message: 'SONAR: Error mapping carriers',
      stack: error?.stack,
    });

    return [];
  }
};
